import {Grid, IconButton, Typography, useTheme} from "@mui/material";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";

const FleetPlanningFooter = (props:any) => {
    const year =props.year; 
    const setYear  = props.setYear;
    const  yearColor =props.yearColor;
    const currYear = new Date().getFullYear()
    const yearsRange:any[] = [currYear-2, currYear+5];

    const previosYear = () => {
        setYear(year - 1);
    };

    const nextYear = () => {
        setYear(year + 1);
    };

    return (
     <div  className="footerClass">
        <Grid
            container
           
            justifyContent="flex-end"
            alignItems="center"
            alignContent='center'        >
            {year > yearsRange[0] && <Grid item xs="auto">
                <IconButton aria-label="export" onClick={previosYear}>
                    <KeyboardArrowLeft/>
                </IconButton>
            </Grid>}
            <Grid item xs="auto">
                <Typography style={{color: yearColor,fontWeight: 800 }}  className ="footerYearClass">
                    {year}
                </Typography>
            </Grid>
            {year < yearsRange.at(-1) && <Grid item xs="auto">
                <IconButton aria-label="export" onClick={nextYear}>
                    <KeyboardArrowRight/>
                </IconButton>
            </Grid>}
        </Grid>
        </div>
    );
}

export default FleetPlanningFooter;
